import React, { Component } from 'react';
import PageTitle from './PageTitle';
import {Link} from 'react-router';

export default class AboutCustom extends Component {

    render() {
        return (
            <div>
                <PageTitle title="Soluções customizadas - FC-Labs Software Lab" last="Home" lastLink="/" />
                <div className="promo-box brand-bg">
                    <div className="container">
                        <div className="col-md-12">
                            <div className="promo-info">
                                <span className="white-text text-uppercase">Descubra a melhor solução para o seu negócio de maneira rápida e confiável.</span>
                                <h2 className="font-30 white-text text-bold text-uppercase no-margin">Solicite seu orçamento!</h2>
                            </div>
                            <div className="promo-btn">
                                <Link className="btn white waves-effect waves-grey" to="/contact/fazer-orçamento">Fazer orçamento</Link>
                            </div>
                        </div>
                    </div>
                </div>
                <section id="about-custom" className="section-padding gray-bg" style={{paddingBottom: '0px'}}>
                    <div className="container">
                        <div className="text-center mb-80">
                            <h2 className="section-title text-uppercase">soluções customizadas</h2>
                            <p className="section-sub">Aconselhamos, ajudamos, projetamos, desenvolvemos e mantemos seu software/aplicação. O software poder ser desenvolvido em escopo aberto ou escopo fechado.</p>
                        </div>                       
                    </div>
                </section>
                <section id="feature" className="section-padding">
                    <div className="container">

                        <div className="row equal-height-row">
                            <div className="col-md-4 mb-30">
                                <div className="featured-item hover-outline brand-hover radius-4 equal-height-column">
                                    <div className="icon">
                                        <i className="material-icons colored brand-icon">devices_other</i>
                                    </div>
                                    <div className="desc">
                                        <h2>Software sob Medida</h2>
                                        <p>Desenvolvemos novos projetos sob medida e mantemos seu sofware/aplicação.</p>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-4 mb-30">
                                <div className="featured-item hover-outline brand-hover radius-4 equal-height-column">
                                    <div className="icon">
                                        <i className="material-icons colored brand-icon">group</i>
                                    </div>
                                    <div className="desc">
                                        <h2>Alocação de Profissionais</h2>
                                        <p>Atendemos empresas de todas aréas e portes. Por isso alocamos nossos profissionais em sua empresa.</p>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-4 mb-30">
                                <div className="featured-item hover-outline brand-hover radius-4 equal-height-column">
                                    <div className="icon">
                                        <i className="material-icons colored brand-icon">lightbulb_outline</i>
                                    </div>
                                    <div className="desc">
                                        <h2>Experiência e Inovação</h2>
                                        <p>Mais de 15 anos de experiência em tecnologia, buscando sempre qualidade e inovação.</p>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-4">
                                <div className="featured-item hover-outline brand-hover radius-4 equal-height-column">
                                    <div className="icon">
                                        <i className="material-icons colored brand-icon">account_balance_wallet</i>
                                    </div>
                                    <div className="desc">
                                        <h2>Custo Competitivo, Alta Qualidade</h2>
                                        <p>Otimizando o plajemento e traçando metas, conseguimos reduzir o custo e ser competivivo.</p>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-4">
                                <div className="featured-item hover-outline brand-hover radius-4 equal-height-column">
                                    <div className="icon">
                                        <i className="material-icons colored brand-icon">access_alarm</i>
                                    </div>
                                    <div className="desc">
                                        <h2>Agilidade nos Processos</h2>
                                        <p>Utilizando ferramentas e metologias que nos permitem agilizar em 3 vezes mais rapidos que as metologias convencionais.</p>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-4">
                                <div className="featured-item hover-outline brand-hover radius-4 equal-height-column">
                                    <div className="icon">
                                        <i className="material-icons colored brand-icon">trending_up</i>
                                    </div>
                                    <div className="desc">
                                        <h2>Aumento de Produtividade</h2>
                                        <p>Sempre pensamento na produtividade dos nossos clientes, reduzindo custos e automatizando processos.</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </section>
                <div class="mocup-wrapper text-center">
                    <img src="../assets/img/mockup/landscap-mockup.jpg" alt="imagem"/>
                </div>
            </div>);
    }

}



// WEBPACK FOOTER //
// ./src/components/AboutCustom.js